import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { Locales } from './token/interfaces';

i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: process.env.REACT_APP_FALLBACK_LANGUAGE,
        whitelist: [Locales.DE, Locales.EN, Locales.PL, Locales.RU],
        debug: false,
        detection: {
            order: ['localStorage', 'cookie'],
            caches: ['localStorage', 'cookie'],
        },
        interpolation: { escapeValue: false },
    });

export default i18next;
